var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplaySlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96967 1.46967C3.26256 1.17678 3.73744 1.17678 4.03033 1.46967L21.5303 18.9697C21.8232 19.2626 21.8232 19.7374 21.5303 20.0303C21.2374 20.3232 20.7626 20.3232 20.4697 20.0303L2.96967 2.53033C2.67678 2.23744 2.67678 1.76256 2.96967 1.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17H4C2.89543 17 2 16.1046 2 15V6.00001C2 5.36671 2.29435 4.80215 2.75371 4.4357L15.318 17H12.75V19.25H15C15.4142 19.25 15.75 19.5858 15.75 20C15.75 20.4142 15.4142 20.75 15 20.75H9C8.58579 20.75 8.25 20.4142 8.25 20C8.25 19.5858 8.58579 19.25 9 19.25H11.25V17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15C22 15.6333 21.7056 16.1979 21.2463 16.5643L8.68198 4H20C21.1046 4 22 4.89543 22 6V15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplaySlash);
export default __webpack_public_path__ + "static/media/display-slash.92b58951fa66dd16ad8625010db9cd6d.svg";
export { ForwardRef as ReactComponent };